import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import getters from './getters'
import Enumeration from './modules/publicEnumeration'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    Enumeration
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
  getters
})
